export default "__VITE_ASSET__99374b87__"